import React from "react";

// A minimal, fast color wheel component for color picking
// Props: color (hex string), onChange (function)
const ColorWheel = ({ color = "#ff0000", onChange }) => {
  // Use a simple <input type="color"> for now for speed and accessibility
  return (
    <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
      <label style={{ color: "#fff", marginRight: 8, fontSize: 12 }}>Color:</label>
      <input
        type="color"
        value={color}
        onChange={e => onChange && onChange(e.target.value)}
        style={{ width: 32, height: 32, border: "none", background: "none", cursor: "pointer" }}
        aria-label="Pick color"
      />
    </div>
  );
};

export default ColorWheel;
